import { render } from "./TabbedReportViewer.vue?vue&type=template&id=78d7ed3b&scoped=true"
import script from "./TabbedReportViewer.vue?vue&type=script&lang=js"
export * from "./TabbedReportViewer.vue?vue&type=script&lang=js"

import "./TabbedReportViewer.vue?vue&type=style&index=0&id=78d7ed3b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d7ed3b"]])

export default __exports__